import { create, StoreApi, UseBoundStore } from 'zustand';

interface DragHeightState {
  initialHeight: number | undefined;
  destinationHeight: number | undefined;
  action: {
    setInitialHeight: (height: number | undefined) => void;
    setDestinationHeight: (height: number | undefined) => void;
  };
}

/**
 * Zustand store to share the heights of the currently dragged item.
 *
 * - initialHeight: The height of the item in its original state (used for DragStart placeholder)
 * - destinationHeight: The height of the item in its dragged state (used for DragEnd placeholder)
 *
 * For most items (like AdmissionCard), both heights are the same.
 * For collapsible items (like AdmissionGroup), initialHeight is the expanded height,
 * and destinationHeight is the collapsed height.
 */
const useDragHeightStore: UseBoundStore<StoreApi<DragHeightState>> = create<DragHeightState>((set) => ({
  initialHeight: undefined,
  destinationHeight: undefined,
  action: {
    setInitialHeight: (height: number | undefined) => set({ initialHeight: height }),
    setDestinationHeight: (height: number | undefined) => set({ destinationHeight: height }),
  },
}));

export const useInitialHeight = () => useDragHeightStore((state) => state.initialHeight);
export const useDestinationHeight = () => useDragHeightStore((state) => state.destinationHeight);
export const useDragHeightActions = () => useDragHeightStore((state) => state.action);
